const userAgent = window.navigator.userAgent

export const platformName = (() => {
  const platforms = [
    { name: 'Tizen', keyword: 'Tizen' },
    { name: 'WebOS', keyword: 'Web0S' },
    { name: 'FireOS', keyword: ['AFT', 'AmazonWebAppPlatform'] },
    { name: 'Linux', keyword: 'Linux' },
    { name: 'Windows', keyword: 'Win' },
    { name: 'MacOS', keyword: 'Mac' },
    { name: 'UNIX', keyword: 'X11' },
  ]

  for (const platform of platforms) {
    if (Array.isArray(platform.keyword)) {
      if (platform.keyword.some((value) => userAgent.includes(value))) {
        return platform.name
      }
    } else if (userAgent.includes(platform.keyword)) {
      return platform.name
    }
  }

  return ''
})()
